import { ChipDownContainer, EllipsisDropdownItem } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { allTrackers } from "app/services/track/track";

import { StatusFilterValue } from "../types";

const values = [StatusFilterValue.InstalledAndRemoved, StatusFilterValue.Installed, StatusFilterValue.Removed];

type StatusFilterProps = {
    value: StatusFilterValue;
    onChange: (value: StatusFilterValue) => void;
    cssClassContainer?: string;
};

export const StatusFilter = ({ value, onChange, cssClassContainer }: StatusFilterProps) => {
    const translate = useTranslation();

    const handleClick = (item: { id: StatusFilterValue }) => {
        onChange(item.id);
        trackStatusSelect(item.id);
    };

    const trackStatusSelect = (status: StatusFilterValue) => {
        const statusText = {
            [StatusFilterValue.InstalledAndRemoved]: "installed and removed",
            [StatusFilterValue.Installed]: "only installed",
            [StatusFilterValue.Removed]: "only removed",
        }[status];

        allTrackers.trackEvent("table filter", "select filter value", `installation status/${statusText}`);
    };

    return (
        <div data-automation="technologies-table.status-filter">
            <ChipDownContainer
                selectedText={
                    value === StatusFilterValue.InstalledAndRemoved ? "" : translate(`si.technology.status.${value}`)
                }
                buttonText={translate(`si.technology.status.${value}`)}
                onCloseItem={() => handleClick({ id: StatusFilterValue.InstalledAndRemoved })}
                onClick={handleClick}
                tooltipDisabled
                selectedIds={{ [value]: true }}
                noResultsMessage={translate("dropdown.no.results")}
                cssClassContainer={cssClassContainer}
            >
                {values.map((value) => (
                    <EllipsisDropdownItem
                        key={value}
                        id={value}
                    >
                        {translate(`si.technology.status.${value}`)}
                    </EllipsisDropdownItem>
                ))}
            </ChipDownContainer>
        </div>
    );
};
